module.exports = __webpack_public_path__ + "static/media/LC.883846e6.png";